// extracted by mini-css-extract-plugin
module.exports = {"PreferredClinicianSelector":"appointments__ClinicianSelection__PreferredClinicianSelector"};